import { apiClient } from "../apiClient";
import { STATUTE_SEARCH_ENDPOINTS, BACKEND_ENDPOINTS } from "../apiEndpoints";

export const searchStatutesApi = (requestBody, signal) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${STATUTE_SEARCH_ENDPOINTS.SEARCH}`,
    requestBody,
    { signal }
  );

export const fetchStatuteSuggestionsApi = (query) =>
  apiClient.get(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${STATUTE_SEARCH_ENDPOINTS.FETCH_SUGGESTIONS}`, { q: query, type: "statute" });
